/**
 * @generated SignedSource<<0089f3c24fe6e6d6f0ee44f4428fa395>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BuyerPriceTableRowTypeType = "ADDITIONAL_CHARGE" | "AUCTION_SECOND_CHANCE_PRICE" | "AUSTRALIAN_GST" | "BUYER_DUTIES_TAX" | "BUY_IT_NOW_PRICE" | "COMPLIMENTARY_SHIPPING" | "CREDIT" | "CURRENT_BID_PRICE" | "CUSTOM_MOD" | "DEALER_SHIPMENT_REFUND" | "FIRSTDIBS_SHIPMENT_REFUND" | "ITEM_REFUND" | "LIST_PRICE" | "NEGOTIATED_DISCOUNT" | "PRICE" | "PRICE_DISCOUNT" | "PRICE_MOD" | "PROMO" | "PROMOTION" | "PUR_PRICE" | "QUANTITY" | "SALES_TAX" | "SHIPPING" | "SHIPPING_SUBSIDY" | "TOTAL" | "TOTAL_REFUND" | "TOTAL_SALES_TAX" | "WINNING_BID_PRICE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutShippingStep_transaction$data = {
  readonly buyerPriceTables: {
    readonly tables: ReadonlyArray<{
      readonly rows: ReadonlyArray<{
        readonly rowType: BuyerPriceTableRowTypeType | null;
        readonly value: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
  readonly isAuctionOrderType: boolean | null;
  readonly isVatOrder: boolean | null;
  readonly serviceId: string | null;
  readonly warnings: {
    readonly isCheckoutBlocked: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PriceBookNameChangeModal_transaction">;
  readonly " $fragmentType": "CheckoutShippingStep_transaction";
};
export type CheckoutShippingStep_transaction$key = {
  readonly " $data"?: CheckoutShippingStep_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutShippingStep_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "displayCurrency"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutShippingStep_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PriceBookNameChangeModal_transaction"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionOrderType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "countryCode",
          "variableName": "userCountryCode"
        }
      ],
      "concreteType": "TransactionWarningQueryType",
      "kind": "LinkedField",
      "name": "warnings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCheckoutBlocked",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "displayCurrency",
          "variableName": "displayCurrency"
        }
      ],
      "concreteType": "BuyerPriceTables",
      "kind": "LinkedField",
      "name": "buyerPriceTables",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BuyerPriceTable",
          "kind": "LinkedField",
          "name": "tables",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BuyerPriceTableRow",
              "kind": "LinkedField",
              "name": "rows",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rowType",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVatOrder",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "b395650f153036c1e9db45f757171cdc";

export default node;
